import React from "react";
import Login from "../../components/login-page/index";

export default function LoginPage() {
  return <Login></Login>;
}
